export { default } from './PrivateNoteDisplay';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/PrivateNoteDisplay/index.js